<tilby-dialog-toolbar
    [title]="data.title | translate"
    [hideCancel]="!!data.hideCancel"
    (confirm)="confirm()"
    [disabled]="optionsForm?.invalid || false"
>
</tilby-dialog-toolbar>

<tilby-dialog-content>
    <form [formGroup]="optionsForm" class="tw-flex tw-flex-col tw-gap-4 tw-p-2">
        <div formArrayName="selections">
            @for(field of data.fields; track $index) {
                <mat-form-field class="tw-w-full tw-mb-2">
                    @if(field.message) {
                        <mat-label>{{ field.message | translate }}</mat-label>
                    }
                    
                    <mat-select [formControlName]="$index" [placeholder]="field.placeholder | translate">
                        @for(option of field.options; track option.value) {
                            <mat-option [value]="option.value">
                                {{ option.name | translate }}
                            </mat-option>
                        }
                    </mat-select>

                    @if(selections.at($index).hasError('required')) {
                        <mat-error>{{ 'NG_MESSAGES.REQUIRED_FIELD' | translate }}</mat-error>
                    }
                </mat-form-field>
            }
        </div>
    </form>
</tilby-dialog-content>